import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b067af886e100014ade3c8/gestpub_diagnostic/src/app/results-and-recommendations/components/ResultsInteractive.tsx");
